import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { AuthenticationService } from './authentication.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
import * as i3 from "./authentication.service";
var ClientLogService = /** @class */ (function () {
    function ClientLogService(http, config, authenticationService) {
        this.http = http;
        this.config = config;
        this.authenticationService = authenticationService;
    }
    ClientLogService.prototype.error = function (data) {
        return this.log(data, "ERROR");
    };
    ClientLogService.prototype.info = function (data) {
        return this.log(data, "INFO");
    };
    ClientLogService.prototype.warning = function (data) {
        return this.log(data, "WARNING");
    };
    ClientLogService.prototype.log = function (data, level) {
        var toLog = { "level": level, "username": this.authenticationService.currentUserValue ? this.authenticationService.currentUserValue.username : null, "data": data };
        return this.http.post(this.config.getConfig("apiEndpoint") + "/log/client", toLog);
    };
    ClientLogService.ngInjectableDef = i0.defineInjectable({ factory: function ClientLogService_Factory() { return new ClientLogService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig), i0.inject(i3.AuthenticationService)); }, token: ClientLogService, providedIn: "root" });
    return ClientLogService;
}());
export { ClientLogService };
